import { useState } from 'react'
import {Route,BrowserRouter as Router,Routes} from "react-router-dom"

// import './App.css'
import LandingPage from './pages/LandingPage'
import Authentication from './pages/Authentication'
import { AuthProvider } from './context/AuthContext.jsx'
import Videomeet from './pages/Videomeet'
import Home from './pages/Home'
import History from './pages/History'


function App() {
  const [count, setCount] = useState(0)

  return (
    <>
      <Router>
        <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage/>}></Route>
          <Route path="/auth" element={<Authentication/>}></Route>
          <Route path="/home" element={<Home/>}></Route>
          <Route path="/history" element={<History/>}></Route>
  
          <Route path='/:url' element={<Videomeet/>}></Route>
        </Routes>
        </AuthProvider>
      </Router>
      
    </>
  )
}

export default App
